import { render, staticRenderFns } from "./notsignedin-forgotpassword.vue?vue&type=template&id=6e642570&scoped=true"
import script from "./notsignedin-forgotpassword.vue?vue&type=script&lang=js"
export * from "./notsignedin-forgotpassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e642570",
  null
  
)

export default component.exports